import React from "react";
import { v4 } from "uuid";
import PageContent from "./PageContent";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import "./Styles/TabStyles.scss";
class TabSegment extends React.Component {
  constructor(props) {
    super(props);
    this.appNavigationDiv = "navigation_" + this.props.appId;
    this.state = {
      tabContent: [],
      activeTab: 0
    };
  }

  componentDidMount() {
    this.prepareTabs();
  }

  prepareTabs = () => {
    if (this.props.tabs.length > 1) {
      let tabContent = [];
      this.props.tabs.map((item, index) => {
        if (item.name === this.props.selectedTab) this.setState({ activeTab: index })
        let uuidv4 = v4();
        let tabContentKey = (item.uuid ? item.uuid : uuidv4) + "_tab";
        let fileData = item.fileData ? item.fileData : {};
        tabContent.push({
          name: item.name,
          uuid: tabContentKey,
          content: (
            <PageContent
              key={tabContentKey}
              notif={this.props.notif}
              config={this.props.config}
              proc={this.props.proc}
              isTab="true"
              appId={this.props.appId}
              parentPage={this.props.pageId}
              fileData={fileData}
              currentRow={this.props.currentRow ?? {}}
              pageContent={item.content}
              pageId={item.pageId}
              fileId={this.props.fileId}
              core={this.props.core}
            />
          ),
        });
      });
      this.setState({
        tabContent: tabContent
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.tabs !== this.props.tabs) {
      this.prepareTabs();
    } else if (prevProps.selectedTab !== this.props.selectedTab) {
      const index = this.props.tabs.findIndex(item => item.name === this.props.selectedTab);
      this.setState({
        activeTab: index !== -1 ? index : 0
      })
    }
  }

  handleSelect = (event) => {
    document.getElementById(this.appNavigationDiv)?.dispatchEvent(new CustomEvent("clearOperationButtons"));
    this.setState({
      activeTab: event.selected
    })
    if (this.props.selectedTab && this.props.selectedTab !== "") {
      this.props.updateSelectedTab(this.props.tabs[event.selected]?.name);
    }
  };

  render() {
    if (this.props.tabs?.length == 1) {
      return (
        <PageContent
          key={this.props.tabs[0].uuid}
          notif={this.props.notif}
          config={this.props.config}
          proc={this.props.proc}
          appId={this.props.appId}
          fileId={this.props.fileId}
          pageContent={this.props.tabs[0].content ? this.props.tabs[0].content : null}
          currentRow={this.props.currentRow ?? {}}
          core={this.props.core}
        />
      );
    } else if (this.props.tabs?.length > 1) {
      return (
        <div className="tabs-container">
          <TabStrip selected={this.state.activeTab} onSelect={(event) => this.handleSelect(event)}>
            {this.state.tabContent?.map((eachTab, index) => {
              return (
                <TabStripTab key={index} title={eachTab.name} style={{ color: "red" }}>
                  <div id={eachTab.uuid} className={`tab_${eachTab.uuid} active_tabstrip`}>
                    {eachTab.content}
                  </div>
                </TabStripTab>
              );
            })}
          </TabStrip>
        </div >
      );
    } else {
      return <div>No Content to Display</div>;
    }
  }
}

export default TabSegment;